import { useState } from "react"
import { AppSpan, CustomContainer, FixedContainer, SidePopupContainer } from "src/style"
import { ServiceRequestAndDispute } from "src/popup"


export const NewCreation: React.FC<any> = ({close}) => {
    const [view, setView] = useState('')
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='transparent' />
            <FixedContainer bottom='17.5' left='6' className="new-creation-container" zIndex="8">
                <CustomContainer 
                    width='21' height='13.5' bgColor='#ffffff' 
                    radius='0.8' padding='1'
                    className='new-creation-box'
                >
                    <AppSpan className="new-creation-text" onClick={() => setView('dispute')} >Log a Dispute</AppSpan>
                    <AppSpan className="new-creation-text" onClick={() => setView('request')} >Create Service Request</AppSpan>
                </CustomContainer>
            </FixedContainer>
            { view &&
                <ServiceRequestAndDispute
                    close={() => setView('')} 
                    type={view === 'request' ? 'serviceRequest' : 'dispute'}
                />
            }
        </>
    )
}